import { render, staticRenderFns } from "./listButtons.vue?vue&type=template&id=60fea8fa&"
import script from "./listButtons.vue?vue&type=script&lang=js&"
export * from "./listButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports